export default "__VITE_ASSET__BgRT_9cG__"